import React from "react";
import i18next from "i18next";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import { ArabicToPersian } from "utils/ConvertToPersianTextFromArabic";
import EditableCustomizableSelect from "Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect";

const ReceiptType = (props) => {
  const paycheck_type_select = FindLangKey(
    "invoice-receipt-label-receipt-type"
  );
  const { receiptTypeList, name, errors, onChange,fishTypeId } = props;

  const initialPaycheckType = receiptTypeList?.find((receiptType)=>receiptType.Id === fishTypeId)

  const initialPaycehckSelectData = [{
    ItemContent:ArabicToPersian(initialPaycheckType?.Name),
    ItemValue:ArabicToPersian(initialPaycheckType?.Name),
  }]

  return (
    <React.Fragment>
      <div>
        <EditableCustomizableSelect
          label={paycheck_type_select}
          isEnglish={i18next.language === "en"}
          initialData={initialPaycehckSelectData}
          SelectableDataArray={receiptTypeList?.map((receipt) => ({
            ItemContent: ArabicToPersian(receipt?.Name),
            ItemValue: receipt?.Id,
          }))}
          isSingle={true}
          name={name}
          errors={errors}
          onChange={onChange}
          enableInitialOnchange={true}
        />
      </div>
    </React.Fragment>
  );
};

export default ReceiptType;
